module.exports = __webpack_public_path__ + "img/card5.b7c46d0f.jpg";